import { render, staticRenderFns } from "./index.vue?vue&type=template&id=edbd1b4a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=edbd1b4a&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edbd1b4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('edbd1b4a')) {
      api.createRecord('edbd1b4a', component.options)
    } else {
      api.reload('edbd1b4a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=edbd1b4a&scoped=true&", function () {
      api.rerender('edbd1b4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/caseHandle/registerSend/index.vue"
export default component.exports